import React from 'react';
import { gradeYearData } from './gradeYearData';
import DropdownListPage from '../../../molecules/dropdownListPage/DropdownListPage';
import appStrings from '../../../../../common/app_strings';
import { useAppState } from '../../../../../providers/app-state/app-state-provider';

const {
  wholeMe: {
    wholeMeGradeYearIntake: {
      title,
      subtitle,
    },
  },
} = appStrings;

const ProfileGradeYearIntakePage = ({
  paginationMeta,
  nextOnClick,
  prevOnClick,
  wholeMeClient,
  exitIconOnClickOverride,
}) => {
  const dataFetcher = wholeMeClient.fetchGradeYearState;
  const dataSaver = wholeMeClient.saveGradeYearState;
  const { platform } = useAppState();

  return (
    <DropdownListPage
      fields={[...gradeYearData.highSchoolGrades, ...gradeYearData.collegeGrades]}
      paginationMeta={paginationMeta}
      nextOnClick={nextOnClick}
      prevOnClick={prevOnClick}
      title={title}
      subtitle={subtitle}
      backgroundOverlay="/assets/overlays/three-lines-top-right-overlay.svg"
      categoryId="identity"
      questionId="grade"
      dataFetcher={dataFetcher}
      dataSaver={dataSaver}
      allowForDisabledButtonState
      mainImage="assets/register/grade-year-intake-child.svg"
      titleStyleOverride={{
        subHeaderStyles: {
          padding: '0 40px 20px 40px',
        },
      }}
      exitIconOnClickOverride={exitIconOnClickOverride}
      mainImageOverrideStyles={{
        paddingLeft: '2rem',
        width: platform?.isNativePlatform ? 'calc(100% - 80px' : 'calc(45% - 80px)',
      }}
    />
  );
};

export default ProfileGradeYearIntakePage;
